import React from "react";
import { connect, useSelector } from "react-redux";
import { Pagination } from "semantic-ui-react";
import SessionalDetailsAction from "../../redux/actions/SessionalDetailsAction";
import SessionalPositionsAction from "../../redux/actions/SessionalPositionsAction";
import DataGrid from "@common/components/shared/DataGrid";
import Filters from "@common/components/shared/Filters";
import useSessionsUtils from "@common/components/hooks/useSessionsUtils";
import {
  handleOptionChange,
  handleSessionsOptionChange,
} from "../helpers/Sessions/sessionsDetailsHelpers";
import useLogin from "../hooks/useLogin";
import Shrink from "@common/components/shared/Shrink";
import TableDetailLayout from "@common/components/shared/TableDetailLayout";
import SetupAction from "@common/redux/actions/SetupAction";

const SessionsDetails = (props) => {
  const {
    displayPositions = true,
    showAlertFilter = false,
    onDetailClick,
  } = props;
  const [{ optionDisplaySessionsInCompliance }] = useLogin();
  const positions = useSelector((state) =>
    SessionalPositionsAction.getStatePath(state),
  );
  const details = useSelector((state) =>
    SessionalDetailsAction.getStatePath(state),
  );
  const { onPositionClick, onPageChange } = useSessionsUtils();

  const showDetails =
    props.displaySessions ||
    optionDisplaySessionsInCompliance ||
    positions.activeRow;

  const mainContent = displayPositions ? (
    <DataGrid
      headings={positions.grid.headerDef}
      data={positions.grid.data}
      rowDef={positions.grid.rowDef}
      onRowClick={onPositionClick}
      className="mb-1"
      activeRow={positions.activeRow}
      fullHeight
    />
  ) : null;

  const detailContent =
    props.displaySessions || optionDisplaySessionsInCompliance ? (
      <>
        <DataGrid
          headings={details.grid.headerDef}
          data={details.grid.data}
          rowDef={details.grid.rowDef}
          onRowClick={onDetailClick}
          onOptionChange={(event, rowIndex, option) => {
            const newGridData = handleOptionChange(
              event,
              details.grid.data,
              rowIndex,
              option,
            );
            handleSessionsOptionChange(
              details.grid.data[rowIndex],
              newGridData,
            );
          }}
        />
        <Shrink>
          <Pagination
            className="mt-1"
            totalPages={details.pageCount}
            activePage={details.pageNumber}
            disabled={!positions.activeRow}
            onPageChange={onPageChange}
          />
        </Shrink>
      </>
    ) : null;

  const filters =
    props.displaySessions || optionDisplaySessionsInCompliance ? (
      <Filters
        shortTerm={props.shortTerm}
        disabled={!positions.activeRow}
        hideShowEvents={props.hideShowEvents}
        showAlertFilter={showAlertFilter}
        onChange={(event, { name, value }) =>
          SessionalDetailsAction.dispatch({ [name]: value })
        }
        {...details}
      />
    ) : null;

  const { uiOrientation } = props.config;

  return (
    <TableDetailLayout
      mainContent={mainContent}
      detailContent={detailContent}
      showDetails={showDetails}
      filters={filters}
      mainColumnWidth={8}
      detailColumnWidth={8}
      uiOrientation={uiOrientation}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    config: SetupAction.getStatePath(state),
  };
};

export default connect(mapStateToProps)(SessionsDetails);
